// extracted by css-extract-rspack-plugin
export default {"placeholder":"_66f63700","modalButtonContainer":"_b5708a99","modalButton":"_7f76cbde","labelSeparator":"_16c8d138"};